import {CoreGraphNodeId} from '../../../../../@polygonjs/polygonjs/src/core/graph/CoreGraph';
import {Vector2Like} from '../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {ref, Ref} from '@vue/composition-api';
export class EditorContextMenuStoreControllerClass {
	private static _instance: EditorContextMenuStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorContextMenuStoreControllerClass());
	}

	private constructor() {}

	private _position!: Ref<Vector2Like>;
	private _nodeId!: Ref<CoreGraphNodeId | null>;
	private _paramId!: Ref<CoreGraphNodeId | null>;
	private _uploadName!: Ref<string | null>;
	init() {
		this._position = ref({
			x: 0,
			y: 0,
		});
		this._nodeId = ref(null);
		this._paramId = ref(null);
		this._uploadName = ref(null);
	}

	// getters

	position(): Vector2Like {
		return this._position.value;
	}
	nodeId(): CoreGraphNodeId | null {
		return this._nodeId.value;
	}
	paramId(): CoreGraphNodeId | null {
		return this._paramId.value;
	}
	uploadName(): string | null {
		return this._uploadName.value;
	}

	// mutations
	setPosition(position: Vector2Like): void {
		this._position.value.x = position.x;
		this._position.value.y = position.y;
	}
	setNodeId(nodeId: CoreGraphNodeId | null): void {
		this._nodeId.value = nodeId;
	}
	setParamId(paramId: CoreGraphNodeId | null): void {
		this._paramId.value = paramId;
	}
	setUploadName(uploadName: string | null): void {
		this._uploadName.value = uploadName;
	}
}

export const EditorContextMenuStoreController = EditorContextMenuStoreControllerClass.instance();
